module.exports = __webpack_public_path__ + "img/step2.394db9d0.png";